// collectionSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { getStoreCollections, getCollectionProducts } from "../../api/collection"
import { addProducts } from "./productSlice"


// ===============================
// INITIAL STATE
// ===============================
const initialState = {

  // collections stored by slug
  collections: {},

  loading: false,

  error: null

}



// ===============================
// FETCH STORE COLLECTION STRUCTURE
// ===============================
export const fetchStoreCollections = createAsyncThunk(

  "collection/fetchStoreCollections",

  async (_, thunkAPI) => {

    try {

      const res = await getStoreCollections()

      return res.data.data.collections

    } catch (err) {

      return thunkAPI.rejectWithValue(err.response?.data)

    }

  }

)


// ===============================
// FETCH COLLECTION PRODUCTS
// ===============================
export const fetchCollectionProducts = createAsyncThunk(

  "collection/fetchCollectionProducts",

  async ({ collectionSlug, subcollectionSlug }, thunkAPI) => {

    try {

      const res = await getCollectionProducts(
        collectionSlug,
        subcollectionSlug
      )

      const products = res.data.data || []

      // store products in productSlice
      thunkAPI.dispatch(addProducts(products))

      return {
        collectionSlug,
        subcollectionSlug,
        products
      }

    } catch (err) {

      return thunkAPI.rejectWithValue(err.response?.data)

    }

  }

)


// ===============================
// COLLECTION SLICE
// ===============================
const collectionSlice = createSlice({

  name: "collection",

  initialState,

  reducers: {

    clearCollectionError: (state) => {
      state.error = null
    }

  },

  extraReducers: (builder) => {

    builder


      // ===============================
      // STORE COLLECTION STRUCTURE
      // ===============================
      .addCase(fetchStoreCollections.fulfilled, (state, action) => {

        const collections = action.payload || []

        collections.forEach(col => {

          const slug = col.slug

          state.collections[slug] = {

            ...col,

            product_ids: [],

            subcollections: {}

          }

          if (Array.isArray(col.subcollections)) {

            col.subcollections.forEach(sub => {

              state.collections[slug].subcollections[sub.slug] = {

                ...sub,

                product_ids: []

              }

            })

          }

        })

      })



      // ===============================
      // STORE COLLECTION PRODUCTS
      // ===============================
      .addCase(fetchCollectionProducts.fulfilled, (state, action) => {

        const { collectionSlug, subcollectionSlug, products } = action.payload

        const collection = state.collections[collectionSlug]

        if (!collection) return


        products.forEach(product => {

          const id = product.id


          if (subcollectionSlug) {

            const sub = collection.subcollections?.[subcollectionSlug]

            if (!sub) return

            if (!sub.product_ids.includes(id)) {

              sub.product_ids.push(id)

            }

          } else {

            if (!collection.product_ids.includes(id)) {

              collection.product_ids.push(id)

            }

          }

        })

      })



      // ===============================
      // ERROR
      // ===============================
      .addCase(fetchCollectionProducts.rejected, (state, action) => {

        state.error = action.payload?.message || "Failed to load products"

      })

  }

})


// ===============================
// EXPORTS
// ===============================
export const { clearCollectionError } = collectionSlice.actions

export default collectionSlice.reducer